import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const reloadPrescriptionAssitant: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  () => void
> = (_set, get) => () => {
  // reset prescription history user actions
  get().updatePrescriptionHistoryItemsToCancel([]);
  get().updatePrescriptionHistoryItemsToReissue([]);
  // reset prescription pad
  get().resetPrescriptionPad();
};
